export default {
  GET_SIDEBAR_ITEMS: (state) => {
    return state.sidebarItems
  },
  GET_TOKEN: (state) => {
    return state.token
  },
  GET_USER_DETAILS: (state) => {
    return state.userDetails
  }
}


// WEBPACK FOOTER //
// ./src/store/getters.js